var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon icon 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8L19.9447 10.25L22.5 10.5605L20.625 12.2502L21 14.75L18.75 13.3438L16.5 14.75L16.875 12.2502L15 10.5605L17.625 10.25L18.75 8Z",
    fill: "#C93030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23H15V19.25C14.9988 18.2558 14.6034 17.3027 13.9004 16.5996C13.1973 15.8966 12.2442 15.5012 11.25 15.5H6.75C5.7558 15.5012 4.80265 15.8966 4.09964 16.5996C3.39664 17.3027 3.00117 18.2558 3 19.25V23H1.5V19.25C1.50163 17.8581 2.05527 16.5237 3.03949 15.5395C4.0237 14.5553 5.35811 14.0016 6.75 14H11.25C12.6419 14.0016 13.9763 14.5553 14.9605 15.5395C15.9447 16.5237 16.4984 17.8581 16.5 19.25V23Z",
    fill: "#C93030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5C9.74168 3.5 10.4667 3.71993 11.0834 4.13199C11.7001 4.54404 12.1807 5.12971 12.4645 5.81494C12.7484 6.50016 12.8226 7.25416 12.6779 7.98159C12.5333 8.70902 12.1761 9.3772 11.6517 9.90165C11.1272 10.4261 10.459 10.7833 9.73159 10.9279C9.00416 11.0726 8.25016 10.9984 7.56494 10.7145C6.87971 10.4307 6.29404 9.95007 5.88199 9.33339C5.46993 8.7167 5.25 7.99168 5.25 7.25C5.25 6.25544 5.64509 5.30161 6.34835 4.59835C7.05161 3.89509 8.00544 3.5 9 3.5ZM9 2C7.96165 2 6.94661 2.30791 6.08326 2.88478C5.2199 3.46166 4.54699 4.2816 4.14963 5.24091C3.75227 6.20022 3.6483 7.25582 3.85088 8.27422C4.05345 9.29262 4.55346 10.2281 5.28769 10.9623C6.02191 11.6965 6.95738 12.1965 7.97578 12.3991C8.99418 12.6017 10.0498 12.4977 11.0091 12.1004C11.9684 11.703 12.7883 11.0301 13.3652 10.1667C13.9421 9.30339 14.25 8.28835 14.25 7.25C14.25 5.85761 13.6969 4.52226 12.7123 3.53769C11.7277 2.55312 10.3924 2 9 2Z",
    fill: "#C93030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManIcon);
export default __webpack_public_path__ + "static/media/man-icon.e0b886cbd887f79a1a20963cedeb9a3b.svg";
export { ForwardRef as ReactComponent };